import api from "../axios";
import Api from "../Api";

export async function UpdateUsers(id, ArrayData) {
  // const response = await api
  //   .put(`${Api.request.URL}/users/${id}`,{ArrayData})
  //   .then((res) => {
  //     return  res.data.msg;
  //   })
  //   .catch((error) => {
  //     return error.response.data.errors;
  //   });
  // return response;

  let config = {
    method: "put",
    maxBodyLength: Infinity,
    url: `${Api.request.URL}/users/${id}`,
    data: ArrayData,
  };

  const response = await api
    .request(config)
    .then((res) => {
      return res.data.msg;
    })
    .catch((error) => {
      return error.response.data.errors;
    });
  return response;
}

  export async function getUserByID(id) {
      const response = await api
        .get(`${Api.request.URL}/users/${id}`)
        .then((res) => {
          // let row = {};
          // res.data.data.map((val) => {
          //     return (row = val);
          // });
          return  res.data.data;
        })
        .catch((error) => {
          return error.response.data.message;
        });
      return response;
}


export async function userList(search,start,limit) {
  const response = await api
    .get(`${Api.request.URL}/users?s=${search === undefined ? "" : search }&start=${start === undefined ? 0 : start }&limit=${limit === undefined ? 10 : limit }`)
    .then((res) => {
      // const result = res.data.data.data.filter((x) => x.isVisible === 1);
      return res.data;
    })
    .catch((error) => {
      return error.response.data.msg;
    });
  return response;
}


export async function userActivation(user_ID,data) {
  let config = {
    method: "put",
    maxBodyLength: Infinity,
    url: `${Api.request.URL}/users/activation/${user_ID}`,
    headers: {},
    data: data,
  };

  const response = await api
    .request(config)
    .then((response) => {
      return response.data.msg;
    })
    .catch((error) => {
      return error.response.data.msg;
    });
  return response;
}